import PageContainer from "../../components/container/PageContainer";
import React, {useEffect, useState} from "react";
import {QueryParams} from "../../types";
import clientesApi from "../../services/clientesApi";
import Alert from "../../helpers/Alert";
import parceirosApi from "../../services/parceirosApi";
import InputIcon from "../../components/input/InputIcon";
import Button from "../../components/button/Button";
import {ReactComponent as AddIcon} from "../../assets/icone/add.svg";
import Table from "../../components/table/Table";
import Modal from '../../components/modal/Modal';
import useModal from '../../hooks/useModal';
import Form from "../../components/form/Form";
import InputSelect from "../../components/input/InputSelect";
import Input from "../../components/input/Input";
import usuariosApi from "../../services/usuariosApi";

export default function Parceiros() {
    const inicialState = {
        id: '',
        name: '',
        empresa: '',
        email: '',
        tipo_id: 3,
        password: '',
        passwordValidate: '',
        segmento: '',
        telefone: '',
        cidade: '',
        estado: '',
        usuario_id: '',
        ativo: 1,
    }
    const [state, setState] = useState(inicialState);

    const [loading, setLoading] = useState(true);
    const [dataPaginate, setDataPaginate] = useState({
        current_page: 1,
        last_page: 2,
        total_data: 0,
        per_page: 0,
    });
    const [data, setData] = useState({});

    const [consulta, setConsulta] = useState('');
    const [atualPageData, setAtualPageData] = useState(1);
    const [porPagina, setPorPagina] = useState(10);
    const { modalProps, open, close } = useModal();
    const columns = [
        { label: "NOME", index: "usuario.name", type: 'string'},
        { label: "EMPRESA", index: "empresa", type: 'string'},
        { label: "SEGMENTO", index: "segmento", type: 'string' },
    ];
    async function getData(atualPage: number, porPagina?: number, busca?: string){
        Alert.await(`Carregando dados...`);
        setLoading(true);
        const params: QueryParams = {
            page: atualPage,
            perPage: porPagina ? porPagina : 10,
            search: busca
        }

        const [parceiros] = await Promise.all([parceirosApi.all(params)]);
        if (!parceiros.isError){
            const parceirosData = parceiros.data.data;
            const paginate = {
                'current_page': parceirosData.current_page,
                'last_page': parceirosData.last_page,
                'total_data': parceirosData.total,
                'per_page': parceirosData.per_page,
            };
            setDataPaginate(paginate);
            setData(parceirosData.data);
        }
        setLoading(false);
        Alert.close();
    }
    useEffect(() => {
        getData(dataPaginate.current_page);
    }, []);
    const onPageChange = (e: number) => {
        getData(e, porPagina);
    }

    const onChangePerPage = (e: number) => {
        setPorPagina(e);
        getData(1, e, consulta);
    }
    const consult = (e: any) => {
        setConsulta(e)

        if (e.length > 3){
            getData(1, porPagina, e);
        }
        if (e.length === 0){
            getData(1)
        }

    }
    const onClickTable = (e: any) => {
       /* console.log(e);
        */
        setState({
            ...e,
            name: e.usuario.name,
            email: e.usuario.email,
            ativo: e.usuario.ativo,
        });
        open()
    }
    const openModal = () => {
        setState(inicialState);
        open()
    }
    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };
    const closeModal = () => {
        setState(inicialState);
        close()
        /*setTimeout(() => {
            setTextTitle('Adicionar usuário')
        }, 1000);*/

    }
    const onSubmit = async () => {
        Alert.await("Salvando dados");
        /*if (state.id){
            // @ts-ignore
            delete state.password;
        }*/
        if (!state.password){
            // @ts-ignore
            delete state.password;
        }
        const {data, isError} = state.id ? await parceirosApi.update(state.id, state) : await parceirosApi.create(state);
        if (isError){
            if (typeof data === 'object') {
                Object.keys(data.errors).forEach(function(key, index) {
                    Alert.error(data.errors[key][0]);
                });
                return;
            }
            return Alert.error(data.data.message? data.data.message : data.data);
        }
        Alert.close();
        Alert.success("Salvo com sucesso");
        close()
        setState(inicialState);
        getData(dataPaginate.current_page);
    }
    return(
        <>
            <PageContainer pageTitle={'Parceiros'}>
                <div className={'md:flex w-full md:justify-between'}>
                    <div className={'grid md:grid-cols-6 gap-4 md:w-[50%]'}>
                        <InputIcon
                            classNameLabel={'md:col-span-3'}
                            name={'nome'}
                            setValue={e => consult(e.target.value)}
                            value={consulta}
                            placeholder={'Pesquisar'}
                        />
                    </div>
                    <div>
                        <Button className={'flex bg-[#082a60] text-white w-[146px] h-[48px] mb-5'} onClick={() => openModal()}>
                            <AddIcon className="fill-white mr-1 " /> Cadastrar
                        </Button>
                    </div>
                </div>
                {
                    loading ? '' :
                        <div className={'w-full'}>
                            <Table
                                columns={columns}
                                tableData={data}
                                data={dataPaginate}
                                onPageChange={onPageChange}
                                setPerPage={onChangePerPage}
                                onClick={onClickTable}
                                perPage={porPagina}
                            />
                        </div>
                }
            </PageContainer>
            <Modal size="lg" title={'Parceiro'} {...modalProps}>
                <Form onSubmit={e => onSubmit()}>
                    <div className={'grid md:grid-cols-1 gap-4'}>
                        <Input
                            large={true}
                            required={true}
                            label="Nome do responsável"
                            value={state.name}
                            setValue={e => handleChange(e, 'name')}
                        />
                        <Input
                            large={true}
                            required={true}
                            label="Nome da empresa"
                            value={state.empresa}
                            setValue={e => handleChange(e, 'empresa')}
                        />

                        <Input
                            large={true}
                            required={true}
                            label="E-mail"
                            value={state.email}
                            setValue={e => handleChange(e, 'email')}
                        />

                        <Input
                            large={true}
                            required={!state.id}
                            label="Senha"
                            inputType='password'
                            value={state.password}
                            setValue={e => handleChange(e, 'password')}
                        />
                        <Input
                            large={true}
                            mask={'cellphone'}
                            label="Telefone"
                            value={state.telefone}
                            setValue={e => handleChange(e, 'telefone')}
                        />
                        <Input
                            large={true}
                            required={true}
                            label="Segmento"
                            value={state.segmento}
                            setValue={e => handleChange(e, 'segmento')}
                        />
                        <Input
                            large={true}
                            label="Cidade"
                            value={state.cidade}
                            setValue={e => handleChange(e, 'cidade')}
                        />
                        <Input
                            large={true}
                            label="Estado"
                            value={state.estado}
                            setValue={e => handleChange(e, 'estado')}
                        />
                        <div >
                            <div className={'flex flex-col'}>
                                <label
                                    className="text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                    Ativo
                                </label>
                                <div className={'flex  gap-4 mt-[1rem]'}>
                                    <div className={'flex'}>
                                        <input
                                            onChange={() => handleChange(1,'ativo')}
                                            value={1}
                                            id="checked-ativo-s"
                                            type="radio"
                                            checked={state.ativo === 1 }
                                            className="w-5 h-5 text-[#061f46] bg-gray-100 accent-[#061f46] border-gray-300 rounded-full focus:ring-[#fff] dark:focus:ring-[#fff] dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                        />
                                        <label
                                            htmlFor="checked-ativo-s"
                                            className="ms-2 text-[16px] font-medium text-gray-900 dark:text-gray-300"
                                        >
                                            Sim
                                        </label>
                                    </div>
                                    <div className={'flex'}>
                                        <input
                                            checked={state.ativo === 0 }
                                            onChange={e => handleChange(0,'ativo')}
                                            id="checked-ativo-n"
                                            type="radio"
                                            value={0}
                                            className="w-5 h-5 text-blue-600 accent-[#061f46] bg-gray-100 border-gray-300 rounded-full focus:ring-[#fff] dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                        />
                                        <label
                                            htmlFor="checked-ativo-n"
                                            className="ms-2 text-[16px] font-medium text-gray-900 dark:text-gray-300"
                                        >
                                            Não
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className={'p-3 flex justify-end mt-5'}>
                        <Button onClick={closeModal} className={'border border-[#061f46] text-[#061f46] '}>
                            Cancelar
                        </Button>
                        <Button type='submit' className={'ml-5 text-white bg-[#061f46]'} >
                            Salvar
                        </Button>
                    </div>

                </Form>
            </Modal>
        </>
    )
}